import axios from 'axios';
import globalMixin from '@/mixins/global-mixin.js';

export default {
  mixins: [globalMixin],
  methods: {
    async initDashTechSession(data) {
      let actions = [];
      if (data.accessToken) {
        actions.push(this.$store.dispatch("setAuthProvider", "DashTech"));
        actions.push(this.$store.dispatch("setAuthenticated", true));
        actions.push(this.$store.dispatch('setAuthError', ""));
        actions.push(this.$store.dispatch('setToken', data.accessToken));
        actions.push(this.$store.dispatch('setTokenExpiration', new Date(data.expirationTime)));
        localStorage.setItem("refreshToken", data.refreshToken);
      }
      actions.push(this.$store.dispatch("setTenantId", data.tenantId));
      actions.push(this.$store.dispatch('setUser', data.userAccount));

      await Promise.all(actions);
    },
    async setupAuth(tokenResponse) {
      let token = tokenResponse.idToken;
      if (token) {
        this.$store.dispatch('setToken', token);
        this.$store.dispatch('setTokenExpiration', tokenResponse.expiresOn);
      } else {
        throw "idToken missing";
      }

      let username = tokenResponse.account.username;
      let preferred = tokenResponse.account.idTokenClaims.preferred_username;
      this.$authService.msal.setActiveAccount(tokenResponse.account);
      let setupUser = async (response) => {
        let actions = [
          this.$store.dispatch('setUser', response.data.userAccount),
          this.$store.dispatch("setAuthenticated", true),
          this.$store.dispatch("setAuthProvider", "Microsoft"),
          this.$store.dispatch('setAuthError', "")
        ];
        if (response.data.tenantId) {
          actions.push(this.$store.dispatch("setTenantId", response.data.tenantId))
        }

        return await Promise.all(actions);
      };

      await axios.get(`${this.$api_url}/users/${username}/permissions`, this.$auth.getReqConfig(token, "Microsoft"))
        .then(setupUser)
        .catch(async (err) => {
          return await axios.get(`${this.$api_url}/users/${preferred}/permissions`, this.$auth.getReqConfig(token, "Microsoft"))
          .then(setupUser)
          .catch(async (err) => {
            await this.$store.dispatch("setAuthError", err.response.data[0]);
            this.logout();
          })
        })
    },
    logout() {
      this.$authService.msal.setActiveAccount(null);
      this.$auth.clearSession().then(() => {
        this.$router.push({ name: "Login" });
      });
    }
  },
  computed: {
    authenticated() {
      return this.$store.getters.getAuthenticated && !this.$store.getters.getPauseAuth;
    },
  }
}